/**
 * Presentational: page title and step counter for Create Organization wizard.
 * Single Responsibility: render title and "STEP X OF N" only.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { PAGE_COPY } from '../constants';

const TITLE_CLASS =
  'font-[\'Roboto:Bold\',sans-serif] font-bold text-[32px] text-black mb-1 leading-tight';
const STEP_CLASS =
  'font-[\'Roboto:Regular\',sans-serif] font-normal text-[14px] text-[#6e6e71] tracking-wide';

export function PageHeader({ title = PAGE_COPY.TITLE, currentStep, totalSteps }) {
  const stepLabel =
    totalSteps != null && currentStep != null
      ? `${PAGE_COPY.STEP_COUNTER_PREFIX} ${currentStep} ${PAGE_COPY.STEP_COUNTER_SUFFIX} ${totalSteps}`
      : null;

  return (
    <div className="mb-8 text-center">
      <h1 className={TITLE_CLASS}>{title}</h1>
      {stepLabel != null && <p className={STEP_CLASS}>{stepLabel}</p>}
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string,
  currentStep: PropTypes.number,
  totalSteps: PropTypes.number,
};
